// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Image_wrapper__2GDy_","img":"Image_img__3Sf14","skeleton":"Image_skeleton__2uasK"};